var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E9FBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2201_19918",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 16,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2201_19918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7004 20.0007H11.2504C10.9837 20.0007 10.7837 19.884 10.6504 19.6507C10.5171 19.4173 10.5282 19.1895 10.6837 18.9673L12.6671 16.0007H12.6171C12.3504 16.0007 12.1532 15.8812 12.0254 15.6423C11.8976 15.4034 11.9115 15.1729 12.0671 14.9507L15.4504 10.1173C15.5171 10.0284 15.6004 9.95898 15.7004 9.90898C15.8004 9.85898 15.9004 9.83398 16.0004 9.83398C16.1004 9.83398 16.2004 9.85898 16.3004 9.90898C16.4004 9.95898 16.4837 10.0284 16.5504 10.1173L19.9337 14.9507C20.0893 15.1729 20.1032 15.4034 19.9754 15.6423C19.8476 15.8812 19.6504 16.0007 19.3837 16.0007H19.3337L21.3171 18.9673C21.4726 19.1895 21.4837 19.4173 21.3504 19.6507C21.2171 19.884 21.0171 20.0007 20.7504 20.0007H17.3004V22.0007C17.3004 22.1895 17.2365 22.3479 17.1087 22.4757C16.981 22.6034 16.8226 22.6673 16.6337 22.6673H15.3671C15.1782 22.6673 15.0199 22.6034 14.8921 22.4757C14.7643 22.3479 14.7004 22.1895 14.7004 22.0007V20.0007ZM12.5004 18.6673H15.1671H13.9004H18.1004H16.8337H19.5004H12.5004ZM12.5004 18.6673H19.5004L16.8337 14.6673H18.1004L16.0004 11.6673L13.9004 14.6673H15.1671L12.5004 18.6673Z",
    fill: "#00A7A6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWood);
export default __webpack_public_path__ + "static/media/wood.830b3a4b960387a4d02689685af340d9.svg";
export { ForwardRef as ReactComponent };